import React from 'react';
import styled from 'styled-components';
import Tooltip from 'rc-tooltip';
import Icon from '../Icon';
import 'rc-tooltip/assets/bootstrap_white.css';
import './style.css';

const TooltipContainer = styled.span`
  width: 12px;
  height: 12px;
  position: relative;
  &:hover {
    cursor: pointer;
  }
  color: ${(props) => (props.iconColor ? props.iconColor : '#b2c3ca')};
`;

const TooltipContent = styled.div`
  border-radius: 2px;
  background-color: white;
  padding: 5px;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  position: relative;

  ::after {
    content: ' ';
    width: 100%;
    margin: auto;
    height: 100%;
    opacity: 0.5;
    top: 5px;
    border-radius: 1.7px;
    -webkit-filter: blur(13.6px);
    filter: blur(13.6px);
    background-color: rgba(0, 0, 0, 0.2);
    z-index: -1;
    position: absolute;
  }

  ${(props) => props.styles};
`;

const Container = styled.div`
  &:hover {
    cursor: ${(props) => (props.noCursor ? 'unset' : 'pointer')};
  }
  width: 100%;
  height: 100%;
  position: relative;
`;

const TooltipCustom = ({
  content,
  placement,
  children,
  iconColor,
  noCursor,
  tooltipContentStyles,
  ...otherProps
}) => (
  <Container noCursor={noCursor}>
    <Tooltip
      placement={placement}
      align={{
        offset:
          placement === 'top'
            ? [0, -10]
            : placement === 'bottom'
              ? [0, 10]
              : placement === 'left'
                ? [-10, 0]
                : placement === 'right'
                  ? [10, 0]
                  : [0, 0]
      }}
      overlayClassName="overlayTooltip"
      overlay={
        <TooltipContent styles={tooltipContentStyles}>{content}</TooltipContent>
      }
      destroyTooltipOnHide
      {...otherProps}
    >
      {children ? (
        children
      ) : (
        <TooltipContainer iconColor={iconColor}>
          <Icon icon="tooltip" />
        </TooltipContainer>
      )}
    </Tooltip>
  </Container>
);

export default TooltipCustom;
